import { useLocation } from "react-router-dom";
import { useDemoMode } from "@/contexts/DemoModeContext";
import { useScreenshotMode } from "@/contexts/ScreenshotModeContext";
import { SCENARIOS } from "@/lib/demoMode/scenarios";

/**
 * Demo Mode status indicator. Only shown inside the admin area — the learner
 * dashboard stays clean for screenshots and marketing videos.
 */
const DemoModeIndicator = () => {
  const { scenario, isDemo } = useDemoMode();
  const { enabled: screenshotMode } = useScreenshotMode();
  const location = useLocation();
  if (!isDemo || !scenario) return null;
  if (screenshotMode) return null;
  if (!location.pathname.startsWith("/admin")) return null;
  return (
    <div className="pointer-events-none fixed top-3 left-1/2 -translate-x-1/2 z-[56] print:hidden">
      <span className="inline-flex items-center gap-1.5 rounded-full bg-primary px-3 py-1 text-[11px] font-semibold uppercase tracking-wider text-primary-foreground shadow-md">
        Demo · {SCENARIOS[scenario].label}
      </span>
    </div>
  );
};

export default DemoModeIndicator;